import { $t } from '@/i18n';
import { getDocLink } from '@utils/links';
import XyPageContainer from './xy-page-container.vue';
import XyPageSchema from './xy-page-schema';
import { XyPageletPropsEditorMeta } from '../uicorePlugin/paramsFormComponents';
import { XyPageContainerTipsMeta, XyInnerPageSelectorMeta, XyInnerPageletSelectorMeta, XyInnerFlowNodePageletConfigMeta } from './meta';

const propPanel = {
  XyInnerPageSelector: XyInnerPageSelectorMeta,
  XyInnerPageletSelector: XyInnerPageletSelectorMeta,
  XyInnerFlowNodePageletConfig: XyInnerFlowNodePageletConfigMeta,
  XyPageletPropsEditor: XyPageletPropsEditorMeta,
  XyPageContainerTips: XyPageContainerTipsMeta,
};

export default {
  component: XyPageContainer,
  componentForDesign: XyPageContainer,
  category: $t('k_f6384246'),
  id: 'xy-page-container',
  methods: [
    {
      id: 'refresh',
      title: $t('k_da780fe2'),
      arguments: [],
      returnValue: {},
    },
  ],
  events: [
    {
      id: 'presetEventA',
      name: $t('k_22042ed4'),
      desc: $t('k_fe78cc40'),
      arguments: [
        {
          type: 'any',
          description: $t('k_a08b60b9'),
        },
      ],
    },
    {
      id: 'presetEventB',
      name: $t('k_2ba647c1'),
      desc: $t('k_fe78cc40'),
      arguments: [
        {
          type: 'any',
          description: $t('k_a08b60b9'),
        },
      ],
    },
    {
      id: 'presetEventC',
      name: $t('k_411bd345'),
      desc: $t('k_fe78cc40'),
      arguments: [
        {
          type: 'any',
          description: $t('k_a08b60b9'),
        },
      ],
    },
    {
      id: 'presetEventD',
      name: $t('k_fb29d0db'),
      desc: $t('k_fe78cc40'),
      arguments: [
        {
          type: 'any',
          description: $t('k_a08b60b9'),
        },
      ],
    },
    {
      id: 'presetEventE',
      name: $t('k_cb2c0538'),
      desc: $t('k_fe78cc40'),
      arguments: [
        {
          type: 'any',
          description: $t('k_a08b60b9'),
        },
      ],
    },
  ],
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-page-container_1636364657577.png',
  slots: [],
  display: 'block',
  visible: true,
  name: $t('k_ccf32c61'),
  readme: getDocLink().PAGELET_DOC ?? '',
  order: 1,
  propPanel,
  propsSchema: XyPageSchema,
  // 预设值
  presets: [],
};
